// This header contains diagnostic hints only. Never use it for authorization.
export const BILLING_TELEMETRY_HEADER = 'x-billing-context';
const TAGS = new Set([
    'trial',
    'dunning',
    'autobilling',
    'incomplete_or_pending',
    'legacy',
    'forceupgrade',
    'force_upgrade',
    'billing_attempt_id',
]);
const IFRAME_FIELDS = new Set([
    'attempt_id',
    'attempt_age_ms',
    'ready_signal_attempted_at',
    'document_visibility_state',
    'navigator_online',
]);

/** Bound and allowlist the same diagnostic fields in both runtimes. */
export function parseBillingTelemetry(value) {
    if (typeof value !== 'string' || value.length > 2048) return { tags: {}, contexts: {} };
    try {
        const parsed = JSON.parse(value);
        const project = (input, keys) =>
            Object.fromEntries(
                Object.entries(input || {}).filter(
                    ([key, entry]) =>
                        keys.has(key) &&
                        (typeof entry === 'boolean' ||
                            (typeof entry === 'number' && Number.isFinite(entry)) ||
                            (typeof entry === 'string' && /^[a-zA-Z0-9_. -]{1,64}$/.test(entry))),
                ),
            );
        return {
            tags: project(parsed?.tags, TAGS),
            contexts: { billing_iframe: project(parsed?.contexts?.billing_iframe, IFRAME_FIELDS) },
        };
    } catch {
        return { tags: {}, contexts: {} };
    }
}
